import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { ThemeSelectors } from '@at/design-system-foundation';
export var BadgeGroupWrapper = styled.ol(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n"])));
export var BadgeGroupItem = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &:not(:last-of-type) {\n        margin-right: ", ";\n    }\n"], ["\n    &:not(:last-of-type) {\n        margin-right: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupOneSpacing(theme);
});
var templateObject_1, templateObject_2;
